import React from 'react';
import {
  Building2,
  MapPin,
  Eye,
  Plus,
  Package
} from 'lucide-react';

const PropertyMobileCard = ({
  property,
  index,
  isRetailManager,
  getPropertyImageUrl,
  getStatusColor,
  formatGLA,
  onOpenModal,
  onAssignAsset
}) => {
  return (
    <div
      key={property.id || index}
      className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
      onClick={() => onOpenModal(property)}
    >
      <div className="flex items-start space-x-4">
        {/* Property Image */}
        <div className="w-16 h-16 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center flex-shrink-0">
          {getPropertyImageUrl(property) ? (
            <img
              src={getPropertyImageUrl(property)}
              alt={property.buildingName || property.building_name || 'Property Image'}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentNode.innerHTML = `<div class="flex items-center justify-center h-full"><div class="text-gray-400">🏢</div></div>`;
              }}
            />
          ) : (
            <Building2 className="h-6 w-6 text-gray-400" />
          )}
        </div>

        {/* Property Details */}
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0 pr-2">
              <h3 className="text-lg font-semibold text-gray-900 truncate" title={property.buildingName || property.building_name || 'Unnamed Property'}>
                {property.buildingName || property.building_name || 'Unnamed Property'}
              </h3>
              <div className="flex items-center space-x-2 mt-1">
                <span className="text-sm text-gray-600 truncate" title={property.sector}>{property.sector || 'N/A'}</span>
                {property.user_added && (
                  <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800 flex-shrink-0">
                    User Added
                  </span>
                )}
              </div>
            </div>

            {/* Mobile Actions - Enhanced touch targets */}
            <div className="flex items-center space-x-1 flex-shrink-0">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenModal(property);
                }}
                className="min-w-[44px] min-h-[44px] p-2 text-cyan-600 hover:text-cyan-900 hover:bg-gray-100 rounded-md flex items-center justify-center"
                title="View Property Details"
                aria-label="View Property Details"
              >
                <Eye size={18} />
              </button>
              {!isRetailManager && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onAssignAsset(property);
                  }}
                  className="min-w-[44px] min-h-[44px] p-2 text-green-600 hover:text-green-900 hover:bg-gray-100 rounded-md flex items-center justify-center"
                  title="Assign Asset to Property"
                  aria-label="Assign Asset to Property"
                >
                  <Plus size={18} />
                </button>
              )}
            </div>
          </div>

          {/* Property Info Grid - Enhanced for mobile */}
          <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
            <div className="flex items-center space-x-1 min-w-0">
              <MapPin size={12} className="text-gray-400 flex-shrink-0" />
              <span className="text-gray-600 truncate" title={`${property.city || ''}, ${property.province || ''}`}>
                {property.city || 'Unknown'}, {property.province || 'Unknown'}
              </span>
            </div>
            <div className="flex items-center space-x-1">
              <Package size={12} className="text-gray-400 flex-shrink-0" />
              <span className="text-gray-600">{property.asset_count || 0} assets</span>
            </div>
            <div className="flex items-center space-x-1 min-w-0">
              <Building2 size={12} className="text-gray-400 flex-shrink-0" />
              <span className="text-gray-600 truncate" title={formatGLA(property.building_gla)}>{formatGLA(property.building_gla)}</span>
            </div>
            <div className="flex items-center justify-start">
              <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(property.status)} flex-shrink-0`}>
                {property.status || 'Unknown'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyMobileCard;
